<template>
  <div class="m-search-collapse">
    <button type="button" @click.prevent="open" :aria-expanded="isActive ? 'true' : 'false'" class="a-btn-pill a-btn-pill--black a-btn-pill--circle m-search-collapse__toggle o-header__search-btn" :title="$t('search.label')">
      <svg class="a-btn-pill__icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#btn-search'" />
      </svg>
    </button>

    <transition>
      <form v-show="isActive" method="GET" :action="searchUrl" role="dialog" aria-labelledby="search-label" class="m-search-collapse__overlay" :aria-expanded="isActive ? 'true' : 'false'">
        <div aria-hidden="true" class="a-btn-pill a-btn-pill--black a-btn-pill--circle m-search-collapse__icon">
          <svg class="a-btn-pill__icon">
            <use :xlink:href="$root.spritePath + '#btn-search'" />
          </svg>
        </div>

        <div class="m-search-collapse__collapse">
          <input ref="input" type="text" name="q" class="m-search-collapse__input" :placeholder="$t('search.global_placeholder')">

          <button type="submit" class="a-btn a-btn--white m-search-collapse__btn">
            <span class="a-btn__label" id="search-label" v-text="$t('search.label')"></span>
            <svg class="a-btn__icon" aria-hidden="true">
              <use :xlink:href="$root.spritePath + '#btn-arrow-right'"/>
            </svg>
          </button>

          <button type="button" @click.prevent="close" class="m-search-collapse__close" :aria-label="$t('search.close')">
            <svg aria-hidden="true">
              <use :xlink:href="$root.spritePath + '#close'"/>
            </svg>
          </button>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>
import allyWhenKey from 'ally.js/when/key'

  export default {
    data: () => ({
      isActive: false,
      keyHandle: null,
      searchUrl: window.searchUrl,
    }),

    mounted() {
      document.addEventListener("touchstart", this.handleEventOutside, { passive: true });
      document.addEventListener("focusin", this.handleEventOutside);
      document.addEventListener("click", this.handleEventOutside);
    },

    unmounted() {
      document.removeEventListener("touchstart", this.handleEventOutside, { passive: true });
      document.removeEventListener("focusin", this.handleEventOutside);
      document.removeEventListener("click", this.handleEventOutside);
    },

    methods: {
      open() {
        this.isActive = true;

        this.$nextTick(() => {
          this.$refs.input.focus();

          this.keyHandle = allyWhenKey({
            escape: () => {
              this.close();
            },
          });
        })
      },

      close() {
        this.isActive = false;
        this.keyHandle ? this.keyHandle.disengage() : null;
      },

      toggle() {
        this.isActive ? this.close() : this.open();
      },

      handleEventOutside(e) {
        if (!this.$el.contains(e.target)) {
          this.close();
        }
      },
    },
  }
</script>
